import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { urls } from "../../../../urls";
import { visibleBidStepKeys, type BidStep } from "./bidWizardSteps";

export const useBidStepNavigation = (
  eventId: string,
  bidId: string,
  collectSupplierPrice: boolean,
  espdTravelsWithBid = true,
) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const rawStep = searchParams.get("step");
  const currentStep: BidStep | null = visibleBidStepKeys(collectSupplierPrice, espdTravelsWithBid).includes(
    rawStep as BidStep,
  )
    ? (rawStep as BidStep)
    : null;

  useEffect(() => {
    if (!currentStep) {
      navigate(urls.portal.bid.edit.go(eventId, bidId).intro);
    }
  }, [currentStep, eventId, bidId, navigate]);

  const navigateToStep = (step: BidStep) => {
    navigate(urls.portal.bid.edit.go(eventId, bidId)[step]);
    window.scrollTo(0, 0);
  };

  return { currentStep, navigateToStep };
};
